import { gql } from "@apollo/client"

export const GET_NOTIFICATION_USERS = gql`
  query Users($staff_id: ID!, $organization_id: ID!) {
    participants(staff_id: $staff_id, organization_id: $organization_id) {
      participant_id
      participant_alias
      participant_name_first
      participant_name_last
    }
    staff: staffsByOrganization(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      staff_id
      staff_alias
      staff_name_first
      staff_name_last
    }
  }
`

export const GET_ORGANIZATIONS = gql`
  query Organizations($staff_id: ID!) {
    organizationsByUid(staff_id: $staff_id) {
      organization_id
      organization_alias
      organization_name
      enterprise_id
      enterprise_name
    }
  }
`

export const GET_PARTICIPANT = gql`
  query GetParticipant(
    $staff_id: ID!
    $participant_id: ID!
    $organization_id: ID!
    $participant_alias: String
  ) {
    participant: participant(
      participant_id: $participant_id
      organization_id: $organization_id
    ) {
      participant_id
      participant_alias
      participant_name_first
      participant_name_last
      participant_email_account
      participant_membership_status
    }

    search: participantAdvancedSearch(
      staff_id: $staff_id
      organization_id: $organization_id
      participant_alias: $participant_alias
    ) {
      participant_id
      participant_alias
      participant_name_first
      participant_name_last
      participant_email_account
      participant_membership_status
    }
  }
`

export const GET_STAFF = gql`
  query GetUser($staff_id: ID) {
    user: usersFromList(list: [$staff_id]) {
      staff_name_first
      staff_name_last
    }
  }
`
